import {
  Paper,
  Typography,
} from '@mui/material';
import UploadIcon from '@mui/icons-material/CloudUpload';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './FileUploadPlaceholder.scss';

const defaultProps = {
  Icon: UploadIcon,
  title: 'Click this area to upload',
  subTitle: null,
  error: null,
};

export default function FileUploadPlaceholder(props) {
  const { Icon, title, subTitle, error } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <Paper className='file-upload-placeholder'>
      <Icon className='file-upload-icon' />
      <Typography variant='h6' className='file-upload-sub-text'>
        { title }
      </Typography>

      {subTitle ? (
        <Typography variant='subtitle2' className='file-upload-sub-title'>
          {subTitle}
        </Typography>
      ) : ''}

      {error ? (
        <Typography variant='subtitle1' className='file-upload-error'>
          {error}
        </Typography>
      ) : ''}
    </Paper>
  );
}
